/**
 * gridUtils.js — shared, pure helpers for the eye-test grid components.
 *
 * Extracted verbatim from RenderingStudioLegacyGrid.jsx (§6.6 A1) so the
 * live in-tree EyeTestGridPanel and the (soon-to-be-deleted) legacy grid
 * share one copy. No behavior change from the legacy originals.
 */

// Maps a per-cell / job status token to the CSS status class the grid
// stylesheet already targets (s-pending / s-rendering / s-success / …).
export const cellStatusClass = (status) => {
  switch (status) {
    case "pending":
      return "s-pending";
    case "rendering":
      return "s-rendering";
    case "success":
      return "s-success";
    case "failed":
      return "s-failed";
    case "skipped":
      return "s-skipped";
    default:
      return "s-idle";
  }
};

// Human-friendly duration. Sub-second → "###ms", else "#.##s".
export const formatDuration = (ms) => {
  if (!ms || !Number.isFinite(ms)) return "";
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
};

// Mirror of the server's GridRenderer.DEFAULT_SAMPLE_TEXT. When a
// CharSpeechSample has no book-derived text (e.g. the seeded default emotion
// group), the server falls back to this single shared line for TTS. We surface
// it here so the pre-render grid shows what will actually be spoken.
// KEEP IN SYNC with server/services/voiceRendering/GridRenderer.js.
export const DEFAULT_SAMPLE_TEXT =
  "She paused at the doorway, choosing her next words carefully.";

// Placeholder shown when a cell has no character-specific line yet. The server
// deliberately returns null sampleText for shared standard-seed (ASEP) prompts
// so a generic line isn't surfaced as if it were this character's own text.
export const NO_TEXT_PLACEHOLDER = "No text recording yet…";

// Resolve the text to show for a cell. Character-specific book/override text is
// present on the cell (server maps resolvedText → sampleText), so we use it
// verbatim. When absent, we return a "missing" state so the UI can render a
// neutral "No text recording yet…" placeholder rather than a shared line.
export const effectiveText = (cell) => {
  const text = cell?.sampleText;
  if (text && String(text).trim()) {
    return { text: String(text), isDefault: false, isMissing: false };
  }
  return { text: NO_TEXT_PLACEHOLDER, isDefault: false, isMissing: true };
};



